import { Controller } from "@hotwired/stimulus";
import Swiper, { Pagination, Navigation } from "swiper";

export default class extends Controller {
    static targets = [
        'swiper',
        'prev',
        'pagination',
        'next',
        'controls',
    ]

    connect() {
        Swiper.use([Pagination, Navigation])

        this.swiper = new Swiper(
            this.element,
            {
                watchOverflow: true,
                loop: false,
                navigation: {
                    prevEl: this.prevTarget,
                    nextEl: this.nextTarget,
                    disabledClass: 'disabled',
                },
                pagination: {
                    el: this.paginationTarget,
                    clickable: false,
                    type: "fraction",
                },
                on: {
                    init: (swiper) => {
                        console.log(swiper.slides );
                        if (swiper.slides.length > 1) {
                            this.controlsTarget.classList.remove('hidden')
                        }
                    },
                },
            },
        );
    }

    disconnect() {
        this.swiper.destroy();
    }
}
